import { useCallback } from 'react';
import { useNavigate, matchRoutes } from 'react-router-dom';
import { useRouteConfig } from '../contexts/RouteConfigContext';
export function useSmartNavigate() {
    const navigate = useNavigate();
    const routes = useRouteConfig();
    return useCallback((to, event) => {
        if (event && (event.metaKey || event.ctrlKey || event.button === 1)) {
            window.open(to, '_blank', 'noopener,noreferrer');
            return;
        }
        const matched = matchRoutes(routes, to);
        if (matched && matched.length > 0) {
            navigate(to);
        }
        else {
            window.location.href = to;
        }
    }, [navigate, routes]);
}
